import { Injectable } from '@angular/core';
import { Observable ,  BehaviorSubject } from 'rxjs';
import { IQuoteRequest } from 'libraries/service/resources/hotel/ISearchParameters';
import { IHotel } from 'libraries/hotel/models/hotel';

/**
 * @deprecated
 */
@Injectable()
export class SharedData {
    public static quotation: BehaviorSubject<any> = new BehaviorSubject(null);
    public static itinerary: BehaviorSubject<any> = new BehaviorSubject(null);
    public static booking: BehaviorSubject<any> = new BehaviorSubject(null);
    public static request: BehaviorSubject<IQuoteRequest> = new BehaviorSubject(null);
    public static blockId: BehaviorSubject<number> = new BehaviorSubject(null);
    public static hotelDetail: BehaviorSubject<IHotel> = new BehaviorSubject(null);
    public static showAutoTravellerMessage: BehaviorSubject<boolean> = new BehaviorSubject(null);

    public setData (variable: string, data: any) {
        SharedData[variable].next(data);
    }

    public unsetData (variable: string) {
        SharedData[variable].next(null);
    }

    public getData (variable: string): Observable<any> {
        return SharedData[variable].asObservable();
    }

    public getCurrentData (variable: string): any {
        return SharedData[variable].getValue();
    }
}
